import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-sm-row align-center justify-space-between" }
const _hoisted_2 = { class: "text-subtitle-1 mb-2 mb-sm-0" }
const _hoisted_3 = { class: "text-h6" }

import { ref, onMounted, onBeforeUnmount, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useCookies } from '@vueuse/integrations/useCookies'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { SESSION_DURATION } from '@/app/constants'


export default {
  __name: 'SessionCountdown',
  setup(__props) {

const route = useRoute()

const store = useStore()
const cookies = useCookies()
const { t } = useI18n()

let timer

const DURATION_SECONDS = SESSION_DURATION * 60

const getSessionStartTime = () => {
  const sessionCookie = cookies.get(`sessionId_${store.state.hotelId}`)
  if (!sessionCookie) return null

  const timestamp = sessionCookie.split('_').pop()
  return parseInt(timestamp)
}

const calculateTimeRemaining = () => {
  const startTime = getSessionStartTime()
  if (!startTime) return 0

  const elapsed = Math.floor((Date.now() - startTime) / 1000)
  return Math.max(0, DURATION_SECONDS - elapsed)
}

const currentTime = ref(calculateTimeRemaining())

const isElapsed = computed(() => currentTime.value <= 0)
const isUrgent = computed(() => currentTime.value <= 5 * 60) // 5 minutes or less
const minutes = computed(() => Math.floor(currentTime.value / 60))
const seconds = computed(() => currentTime.value % 60)
const progressValue = computed(
  () => (currentTime.value / DURATION_SECONDS) * 100
)

const startTimer = () => {
  currentTime.value = calculateTimeRemaining()
  timer = setInterval(() => {
    currentTime.value = calculateTimeRemaining()

    if (currentTime.value <= 0) {
      clearInterval(timer)
    }
  }, 1000)
}

onMounted(() => {
  startTimer()
})

onBeforeUnmount(() => {
  if (timer) {
    clearInterval(timer)
  }
})

return (_ctx, _cache) => {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")
  const _component_v_card_item = _resolveComponent("v-card-item")
  const _component_v_card = _resolveComponent("v-card")

  return _withDirectives((_openBlock(), _createBlock(_component_v_card, {
    class: _normalizeClass(['mx-auto my-2 mt-10', { 'urgency-countdown': isUrgent.value }]),
    variant: "elevated"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_progress_linear, {
        "model-value": progressValue.value,
        color: "primary",
        height: "4",
        location: "top"
      }, null, 8, ["model-value"]),
      _createVNode(_component_v_card_item, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('App#Session#SessionCountdown#Title')), 1),
            _createElementVNode("div", _hoisted_3, _toDisplayString(minutes.value) + ":" + _toDisplayString(seconds.value.toString().padStart(2, '0')), 1)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"])), [
    [_vShow, currentTime.value > 0 && _unref(route).name !== 'ReservationCheckoutConfirmation']
  ])
}
}

}